module.exports = __webpack_public_path__ + "static/media/kartikr.cc691bb4.jpg";